import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import * as moment from 'moment';
import { retry } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { UpperCasePipe } from '@angular/common';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr'
import { MisAttachmentViewComponent } from '../mis-attachment-view/mis-attachment-view.component';

@Component({
  selector: 'app-edit-kpipopup',
  templateUrl: './edit-kpipopup.component.html',
  styleUrls: ['./edit-kpipopup.component.scss'],
  providers: [UpperCasePipe]
})
export class EditKPIPopupComponent implements OnInit {

  buttonColorName: any;
  editKPIInformationForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  getMonthsByFiscalandReviewCycle: any = [];
  loggedInUserId: any;
  operation: any;
  kpiId: any = null;
  goalApprovalStatus: boolean = false;
  fileName: any = null;
  fileType: any = null;
  selectedTab: any;
  selectedUserID: any;
  fromYear: any;
  toYear: any;
  loggedInCompanyReviewCycle: any;
  getMonthsForMilestoneFrom: any = [];
  getMonthsForMilestoneTo: any = [];
  invalidReviewCycleWeightage: boolean = false;
  selectedYearReviewCycle: any;
  loggedInUserRole: any;
  isFieldsDisabled: boolean = false;
  addFormSubmitted: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private config: Config,
    public dialogRef: MatDialogRef<EditKPIPopupComponent>, private fb: FormBuilder, public sharedService: SharedService,
    private encryptionService: EncryptionService, private datePipe: DatePipe, private loader: LoaderService,
    public dialog: MatDialog, private upperCasePipe: UpperCasePipe, public toastr: ToastrService) { }
  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;

    this.operation = this.data?.operation;
    this.kpiId = this.data?.kpiId;
    this.selectedTab = this.data?.selectedTab;
    this.selectedUserID = this.data?.selectedUserID;
    this.fromYear = this.data?.fromYear;
    this.toYear = this.data?.toYear;
    if (this.data?.kpiId != null) {
      this.kpiId = this.data?.kpiId;
    } else {
      this.kpiId = null;
    }
    this.initilaizeAddKPIForm();
    this.getPMSSetUpByID();
    // this.calculateMonths();
    this.getMonths();
    if (this.operation == 'Edit') {
      this.getGoalById();
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  initilaizeAddKPIForm() {
    this.editKPIInformationForm = this.fb.group({
      companyId: [this.loggedInUserCompanyID, Validators.required],
      employeeComment: [null],
      id: [null],
      kpi: ['', [Validators.required, Validators.maxLength(255)]],
      kra: ['', [Validators.required, Validators.maxLength(255)]],
      lesserIsBetter: [null, Validators.required],
      managerComment: [null],
      managerId: [null],
      milestoneFrom: [null],
      milestoneTo: [null],
      month: [null, Validators.required],
      target: [null, Validators.required],
      uom: ['', Validators.required],
      userId: [this.loggedInUserId],
      weightage: [null, [Validators.required, this.nonNegativeNumberValidator()]],
      actual: [null],
      misFileName: [null],
      misAttachment: [null],
      percentageAchievement: [null],
      kpiScore: [null]
    })
  }
  nonNegativeNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isNegative = control.value < 0;
      return isNegative ? { 'negativeNumber': { value: control.value } } : null;
    }
  }
  getGoalById() {
    this.httpService.callGetService(this.config.getGoalById + this.kpiId)
      .subscribe((data: any) => {
        this.goalApprovalStatus = data?.data?.goalApprovalStatus;
        this.editKPIInformationForm.controls['id'].setValue(data?.data?.id);
        this.editKPIInformationForm.controls['companyId'].setValue(this.loggedInUserCompanyID);
        this.editKPIInformationForm.controls['employeeComment'].setValue(data?.data?.employeeComment ? data?.data?.employeeComment : null);
        this.editKPIInformationForm.controls['kpi'].setValue(data?.data?.kpi);
        this.editKPIInformationForm.controls['kra'].setValue(data?.data?.kra);
        this.editKPIInformationForm.controls['lesserIsBetter'].setValue(data?.data?.lesserIsBetter);
        this.editKPIInformationForm.controls['managerComment'].setValue(data?.data?.managerComment ? data?.data?.managerComment : null);
        this.editKPIInformationForm.controls['milestoneFrom'].setValue(this.toProperCase(data?.data?.milestoneFrom));
        this.editKPIInformationForm.controls['milestoneTo'].setValue(this.toProperCase(data?.data?.milestoneTo));
        this.editKPIInformationForm.controls['month'].setValue(data?.data?.month);
        this.editKPIInformationForm.controls['target'].setValue(data?.data?.target);
        this.editKPIInformationForm.controls['uom'].setValue(data?.data?.uom);
        this.editKPIInformationForm.controls['userId'].setValue(this.loggedInUserId);
        this.editKPIInformationForm.controls['weightage'].setValue(data?.data?.weightage);
        this.editKPIInformationForm.controls['actual'].setValue(data?.data?.actual);
        this.editKPIInformationForm.controls['misAttachment'].setValue(data?.data?.misAttachment);
        this.editKPIInformationForm.controls['misFileName'].setValue(data?.data?.misFileName);
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(data?.data?.percentageAchievement?.toFixed(2));
        this.editKPIInformationForm.controls['kpiScore'].setValue(parseFloat(data?.data?.kpiScore?.toFixed(2)));
        this.fromYear = data?.data?.fromYear;
        this.toYear = data?.data?.toYear;
        this.getToMonths(data?.data?.milestoneFrom);
        this.getPmsUnlockSetupForUser();
      }, (error: any) => {
      }, () => { });
  }
  getMonths() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    }
    this.httpService.callPostService(this.config.getMonths, request).subscribe((data: any) => {
      this.getMonthsByFiscalandReviewCycle = data.data?.months;
      this.selectedYearReviewCycle = data.data?.reviewCycle;
      this.getMonthsForMilestoneFrom = [];
      this.getMonthsForMilestoneTo = [];
      if (this.selectedYearReviewCycle == 'Monthly') {
        data?.data?.months?.forEach((ele: any) => {
          var fromMonth = ele?.split('-')
          this.getMonthsForMilestoneFrom.push(fromMonth[0]);
        });
      } else {
        data?.data?.months?.forEach((ele: any) => {
          this.getMonthsForMilestoneFrom.push(ele);
        });
      }
      // data?.data?.months?.forEach((ele: any) => {
      //   var toMonth = ele?.split('-')
      //   this.getMonthsForMilestoneTo.push(toMonth[1]);
      // });
    })
  }
  periods = [
    { label: 'Jan_Dec', start: 0, end: 11 },
    { label: 'Apr_Mar', start: 3, end: 2 },
    { label: 'July_Jun', start: 6, end: 5 },
    { label: 'Oct_Sep', start: 9, end: 8 }
  ];
  selectedPeriod = this.periods[0];
  milestoneMonthsList: any = [];
  getToMonths(month1: string) {
    if (this.editKPIInformationForm.value?.milestoneFrom == null) {
      this.editKPIInformationForm.controls['milestoneTo'].setValue(null);
      this.addFormSubmitted = false;
    }
    if (this.selectedYearReviewCycle == 'Monthly') {
      var month = this.toProperCase(month1)
      const startIndex = this.getMonthsForMilestoneFrom.indexOf(month);
      if (startIndex !== -1) {
        this.getMonthsForMilestoneTo = this.getMonthsForMilestoneFrom.slice(startIndex);
      } else {
        this.getMonthsForMilestoneTo = [];
      }
    } else {
      const startIndex = this.getMonthsForMilestoneFrom.indexOf(month1);
      if (startIndex !== -1) {
        this.getMonthsForMilestoneTo = this.getMonthsForMilestoneFrom.slice(startIndex + 1);
      } else {
        this.getMonthsForMilestoneTo = [];
      }
    }
  }
  calculateMonths() {
    if (this.periods[0].label = this.loggedInCompanyFiscalyear) {
      this.selectedPeriod = this.periods[0];
    }
    if (this.periods[1].label = this.loggedInCompanyFiscalyear) {
      this.selectedPeriod = this.periods[1];
    }
    if (this.periods[2].label = this.loggedInCompanyFiscalyear) {
      this.selectedPeriod = this.periods[2];
    }
    if (this.periods[3].label = this.loggedInCompanyFiscalyear) {
      this.selectedPeriod = this.periods[3];
    }
    const currentMonth = moment().month();
    const { start: startMonth, end: endMonth } = this.selectedPeriod;
    let monthsArray = [];
    let start = (currentMonth > startMonth) ? currentMonth : startMonth;
    let i = start;
    while (true) {
      monthsArray.push(moment().month(i).format('MMMM'));
      if (i === endMonth) break;
      i = (i + 1) % 12;
    }
    this.milestoneMonthsList = monthsArray;

  }
  addGoalSetting() {

    this.addFormSubmitted = true;
    if (this.selectedTab == 'My Goals') {
      this.editKPIInformationForm.controls['managerId'].setValue(null)
      this.editKPIInformationForm.controls['userId'].setValue(Number(this.loggedInUserId))
    } else {
      this.editKPIInformationForm.controls['managerId'].setValue(Number(this.loggedInUserId))
      this.editKPIInformationForm.controls['userId'].setValue(this.selectedUserID)
    }
    this.editKPIInformationForm.markAllAsTouched();
    if (this.editKPIInformationForm.value?.milestoneFrom == null) {
      this.editKPIInformationForm.controls['milestoneTo'].clearValidators();
      this.addFormSubmitted = false;
    } else {
      this.editKPIInformationForm.controls['milestoneTo'].setValidators([Validators.required]);
    }
    this.editKPIInformationForm.controls['milestoneTo'].updateValueAndValidity();
    if (this.editKPIInformationForm.valid && !this.invalidReviewCycleWeightage && !this.isCuttofDateActive) {
      const request = {
        companyId: this.editKPIInformationForm.value.companyId,
        employeeComment: this.editKPIInformationForm.value.employeeComment,
        fromYear: this.fromYear,
        id: this.editKPIInformationForm.value.id,
        kpi: this.editKPIInformationForm.value.kpi,
        kra: this.editKPIInformationForm.value.kra,
        lesserIsBetter: this.editKPIInformationForm.value.lesserIsBetter,
        loggedInUserRole: this.loggedInUserRole,
        managerComment: this.editKPIInformationForm.value.managerComment,
        managerId: this.editKPIInformationForm.value.managerId,
        milestoneFrom: this.upperCasePipe?.transform(this.editKPIInformationForm.value?.milestoneFrom || null),
        milestoneTo: this.upperCasePipe?.transform(this.editKPIInformationForm.value?.milestoneTo || null),
        month: this.editKPIInformationForm.value.month,
        target: this.editKPIInformationForm.value.target,
        toYear: this.toYear,
        uom: this.editKPIInformationForm.value.uom,
        userId: this.editKPIInformationForm.value.userId,
        weightage: this.editKPIInformationForm.value.weightage,
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.addGoalSetting, request)
        .subscribe((data: any) => {
          this.loader.dismissLoader();
          this.addFormSubmitted = false;
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              // this.closeDialog();
            });
          }
        }, (error: any) => {
          this.loader.dismissLoader();
        }, () => { });
    }
  }
  editGoalSetting() {
    // if (this.goalApprovalStatus) {
    // if(this.selectedTab === 'Employee Goals'){
    //   this.updateGoalSetting();
    // }else{
    // this.editGoalSettingForReview();
    // }

    if (this.commentLength == false) {
      this.editGoalSettingHRAdmin();
    } else {
      this.toastr.error('The text cannot exceed 255 characters.', '', {
        timeOut: 3000,
      });
    }
    // } else {
    //   this.updateGoalSetting();
    // }
  }
  updateGoalSetting() {
    this.editKPIInformationForm.markAllAsTouched();
    if (this.editKPIInformationForm.valid && !this.invalidReviewCycleWeightage) {
      const request = {
        companyId: this.editKPIInformationForm.value.companyId,
        employeeComment: this.editKPIInformationForm.value.employeeComment,
        fromYear: this.fromYear,
        id: this.editKPIInformationForm.value.id,
        kpi: this.editKPIInformationForm.value.kpi,
        kra: this.editKPIInformationForm.value.kra,
        lesserIsBetter: this.editKPIInformationForm.value.lesserIsBetter,
        managerId: this.editKPIInformationForm.value.managerId,
        milestoneFrom: this.upperCasePipe?.transform(this.editKPIInformationForm.value?.milestoneFrom || null),
        milestoneTo: this.upperCasePipe?.transform(this.editKPIInformationForm.value?.milestoneTo || null),
        month: this.editKPIInformationForm.value.month,
        target: this.editKPIInformationForm.value.target,
        toYear: this.toYear,
        uom: this.editKPIInformationForm.value.uom,
        userId: this.editKPIInformationForm.value.userId,
        weightage: this.editKPIInformationForm.value.weightage,
      }
      this.loader.simpleLoader();
      this.httpService.callPostService(this.config.editGoalSetting, request)
        .subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            // if (this.goalApprovalStatus) {
            //   if(this.selectedTab === 'Employee Goals'){
            //     this.editGoalSettingForReview();
            //   }
            // }
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              // this.closeDialog();
            });
          }
        }, (error: any) => {
          this.loader.dismissLoader();
        }, () => { });
    }
  }
  editGoalSettingForReview() {
    this.editKPIInformationForm.markAllAsTouched();
    // if(this.selectedTab === 'My Goals'){
    //   this.editKPIInformationForm.controls['employeeComment'].setValidators([Validators.required]);
    //   this.editKPIInformationForm.controls['managerComment'].clearValidators();
    // }else{
    //   this.editKPIInformationForm.controls['employeeComment'].clearValidators();
    //   this.editKPIInformationForm.controls['managerComment'].setValidators([Validators.required]);
    // }
    // this.editKPIInformationForm.controls['employeeComment'].updateValueAndValidity();
    // this.editKPIInformationForm.controls['managerComment'].updateValueAndValidity();

    if (this.editKPIInformationForm.valid) {
      const request = {
        actual: this.editKPIInformationForm.value.actual,
        companyId: this.editKPIInformationForm.value.companyId,
        employeeComment: this.editKPIInformationForm.value.employeeComment,
        id: this.editKPIInformationForm.value.id,
        kpiScore: this.editKPIInformationForm.value.kpiScore,
        managerComment: this.editKPIInformationForm.value.managerComment,
        misAttachment: this.editKPIInformationForm.value.misAttachment,
        misFileName: this.editKPIInformationForm.value.misFileName,
        percentageAchievement: this.editKPIInformationForm.value.percentageAchievement
      }
      this.httpService.callPostService(this.config.editGoalSettingForReview, request)
        .subscribe((data: any) => {
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  editGoalSettingHRAdmin() {
    if (this.selectedTab == 'My Goals') {
      this.editKPIInformationForm.controls['managerId'].setValue(null)
      this.editKPIInformationForm.controls['userId'].setValue(Number(this.loggedInUserId))
    } else {
      this.editKPIInformationForm.controls['managerId'].setValue(Number(this.loggedInUserId))
      this.editKPIInformationForm.controls['userId'].setValue(this.selectedUserID)
    }
    this.editKPIInformationForm.markAllAsTouched();
    if (this.editKPIInformationForm.value?.milestoneFrom == null) {
      this.editKPIInformationForm.controls['milestoneTo'].clearValidators();
    } else {
      this.addFormSubmitted = true;
      this.editKPIInformationForm.controls['milestoneTo'].setValidators([Validators.required]);
    }
    this.editKPIInformationForm.controls['milestoneTo'].updateValueAndValidity();
    if (this.editKPIInformationForm.valid) {
      const request = {
        actual: this.editKPIInformationForm.value.actual,
        companyId: this.editKPIInformationForm.value.companyId,
        employeeComment: this.editKPIInformationForm.value.employeeComment,
        fromYear: this.fromYear,
        id: this.editKPIInformationForm.value.id,
        kpi: this.editKPIInformationForm.value.kpi,
        kpiScore: this.editKPIInformationForm.value.kpiScore,
        kra: this.editKPIInformationForm.value.kra,
        lesserIsBetter: this.editKPIInformationForm.value.lesserIsBetter,
        loggedInUserRole: this.loggedInUserRole,
        managerComment: this.editKPIInformationForm.value.managerComment,
        managerId: this.editKPIInformationForm.value.managerId,
        milestoneFrom: this.upperCasePipe?.transform(this.editKPIInformationForm.value?.milestoneFrom || null),
        milestoneTo: this.upperCasePipe?.transform(this.editKPIInformationForm.value?.milestoneTo || null),
        misAttachment: this.editKPIInformationForm.value.misAttachment,
        misFileName: this.editKPIInformationForm.value.misFileName,
        month: this.editKPIInformationForm.value.month,
        percentageAchievement: this.editKPIInformationForm.value.percentageAchievement,
        target: this.editKPIInformationForm.value.target,
        toYear: this.toYear,
        uom: this.editKPIInformationForm.value.uom,
        userId: this.editKPIInformationForm.value.userId,
        weightage: this.editKPIInformationForm.value.weightage,
      }
      this.httpService.callPostService(this.config.editGoalSettingHRAdmin, request)
        .subscribe((data: any) => {
          this.addFormSubmitted = false;
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.closeDialog();
            });
          } else {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
            });
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  isLoading = false;
  uploadImage(event: any) {
    const fileSizeInKB = event.target.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }
    var flag = true;
    // if (flag) {
    //   const fileName = event.target.files[0].name;
    //   const fileType = event.target.files[0].type;
    //   const formData = new FormData();
    //   formData.append('file', event.target.files[0]);
    //   // const url = this.config.uploadFileLocally + `?fileName=${fileName}&fileType=${fileType}`
    //    const url = this.config.uploadFileLocallymultipleForPMS;
    //   this.loader.simpleLoader();
    //   this.httpService.submitFormService(url, formData).subscribe((res: any) => {
    //     this.fileName = event.target.files[0].name;
    //     this.fileType = event.target.files[0].type;

    //     this.editKPIInformationForm.controls['misFileName'].setValue(this.fileName);
    //     this.editKPIInformationForm.controls['misAttachment'].setValue(res.data);
    //     this.loader.dismissLoader();
    //   }, (error: any) => {
    //     this.loader.dismissLoader();
    //   })
    // }

    if (flag) {
      const files: FileList = event.target.files;
      if (files && files.length > 0) {
        const formData = new FormData();

        // Backend expects all files under the 'files' key
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i]);                     // use 'files' key
          formData.append('fileType', files[i].type.split('/')[0]); // optional: send types
        }
        this.isLoading = true;
        this.loader.simpleLoader();
        const url = this.config.uploadFileLocallymultipleForPMS;

        this.httpService.submitFormService(url, formData).subscribe(
          (res: any) => {
            const fileNames = Array.from(files).map(f => f.name).join(', ');
            const fileTypes = Array.from(files).map(f => f.type.split('/')[0]).join(', ');

            this.fileName = fileNames;
            this.fileType = fileTypes;

            this.editKPIInformationForm.controls['misFileName'].setValue(fileNames);
            this.editKPIInformationForm.controls['misAttachment'].setValue(res.data);
            this.isLoading = false;
            this.loader.dismissLoader();

          },
          (error: any) => {
            this.isLoading = false;
            this.loader.dismissLoader();
          }
        );
      }
    }



  }
  onRemovemisAttachment() {
    this.editKPIInformationForm.controls['misFileName'].setValue(null);
    this.editKPIInformationForm.controls['misAttachment'].setValue(null);
  }
  capValue: boolean = false;
  capSelect: any;
  scoreRange: any = [];
  straightScore: any;
  valueSelectMonthlyCap: any;
  cutoffDateApplicable: boolean = false;
  gracePeriod: any = null;
  cutoffDate: any = null;
  getPMSSetUpByID() {
    this.httpService.callGetService(this.config.getPMSSetUpByID + this.loggedInUserCompanyID + '/' + this.fromYear + '/' + this.toYear).subscribe((data: any) => {
      if (data?.data != null) {
        this.capValue = data?.data?.capValue;
        this.capSelect = data?.data?.capSelect;
        this.scoreRange = data?.data?.addScores;
        this.valueSelectMonthlyCap = data?.data?.valueSelect;
        this.straightScore = Number(data?.data?.comment);
        this.cutoffDateApplicable = data?.data?.cutoffDateApplicable;
        this.gracePeriod = data?.data?.gracePeriod;
        this.cutoffDate = data?.data?.cutoffDate;
      }
    })
  }
  percentageAchievement: any = 0;
  calculateAchievement() {
    if (this.editKPIInformationForm.value.actual == null) {
      this.editKPIInformationForm.controls['kpiScore'].setValue(null)
      this.editKPIInformationForm.controls['percentageAchievement'].setValue(null)
      return;
    }

    if (this.editKPIInformationForm.value.lesserIsBetter) { //lesserIsBetter Yes

      // + Actual and + Target
      if (this.editKPIInformationForm.value.target > 0 && this.editKPIInformationForm.value.actual > 0) {
        this.percentageAchievement = this.editKPIInformationForm.value.target / this.editKPIInformationForm.value.actual * 100;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(
          parseFloat((this.editKPIInformationForm.value.target / this.editKPIInformationForm.value.actual * 100)?.toFixed(2)));
      }
      // - Actual and - Target
      else if (this.editKPIInformationForm.value.target < 0 && this.editKPIInformationForm.value.actual < 0) {
        this.percentageAchievement = this.editKPIInformationForm.value.actual / this.editKPIInformationForm.value.target * 100;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(
          parseFloat((this.editKPIInformationForm.value.actual / this.editKPIInformationForm.value.target * 100)?.toFixed(2)));
      }
      //Actual = 0 and Target = 0
      else if (this.editKPIInformationForm.value.target == 0 && this.editKPIInformationForm.value.actual == 0) {
        this.percentageAchievement = 100;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(100);
      }
      //Actual > 0 and Target = 0
      else if (this.editKPIInformationForm.value.target == 0 && this.editKPIInformationForm.value.actual > 0) {
        // this.percentageAchievement = (this.editKPIInformationForm.value.actual + 1) * 100;
        // this.editKPIInformationForm.controls['percentageAchievement'].setValue((this.editKPIInformationForm.value.actual + 1) * 100);
        const actual = this.editKPIInformationForm.value.actual;
        const target = this.editKPIInformationForm.value.target;

        if (target && target !== 0) {
          const percentageAchievement = (actual / target) * 100;
          this.percentageAchievement = percentageAchievement;
          this.editKPIInformationForm.controls['percentageAchievement'].setValue(percentageAchievement);
        } else {
          this.percentageAchievement = 0;
          this.editKPIInformationForm.controls['percentageAchievement'].setValue(0);
        }
      }
      //Actual = 0 and Target > 0
      else if (this.editKPIInformationForm.value.target > 0 && this.editKPIInformationForm.value.actual == 0) {
        this.percentageAchievement = 100;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(100);
      }
    } else {
      //lesserIsBetter No ----------------
      // + Actual and + Target
      if (this.editKPIInformationForm.value.target > 0 && this.editKPIInformationForm.value.actual > 0) {
        this.percentageAchievement = parseFloat((this.editKPIInformationForm.value.actual / this.editKPIInformationForm.value.target * 100)?.toFixed(2));
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(
          parseFloat((this.editKPIInformationForm.value.actual / this.editKPIInformationForm.value.target * 100)?.toFixed(2)));
      }
      // - Actual and - Target
      else if (this.editKPIInformationForm.value.target < 0 && this.editKPIInformationForm.value.actual < 0) {
        this.percentageAchievement = this.editKPIInformationForm.value.target / this.editKPIInformationForm.value.actual * 100;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(
          parseFloat((this.editKPIInformationForm.value.target / this.editKPIInformationForm.value.actual * 100)?.toFixed(2)));
      }
      //Actual = 0 and Target = 0
      else if (this.editKPIInformationForm.value.target == 0 && this.editKPIInformationForm.value.actual == 0) {
        this.percentageAchievement = 100;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(100);
      }
      //Actual > 0 and Target = 0
      else if (this.editKPIInformationForm.value.target == 0 && this.editKPIInformationForm.value.actual > 0) {
        this.percentageAchievement = (this.editKPIInformationForm.value.actual + 1) * 100;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(parseFloat(((this.editKPIInformationForm.value.actual + 1) * 100)?.toFixed(2)));
      }
      //Actual = 0 and Target > 0
      else if (this.editKPIInformationForm.value.target > 0 && this.editKPIInformationForm.value.actual == 0) {
        this.percentageAchievement = 0;
        this.editKPIInformationForm.controls['percentageAchievement'].setValue(0);
      }
    }
    if (this.valueSelectMonthlyCap == 'Monthly_Cut_off') {
      if (this.capSelect == 'Straight') {
        if (this.percentageAchievement > this.straightScore) {
          this.editKPIInformationForm.controls['percentageAchievement'].setValue(parseFloat(this.straightScore?.toFixed(2)));
        }
      } else if (this.capSelect == 'Range') {
        for (let i = 0; i < this.scoreRange?.length; i++) {
          if (this.percentageAchievement >= this.scoreRange[i].maxRange) {
            this.editKPIInformationForm.controls['percentageAchievement'].setValue((Number(this.scoreRange[i].normalizeScore))?.toFixed(2));
          }
          if (this.percentageAchievement > this.scoreRange[i].minRange
            && this.percentageAchievement < this.scoreRange[i].maxRange) {
            this.editKPIInformationForm.controls['percentageAchievement'].setValue((Number(this.scoreRange[i].normalizeScore)?.toFixed(2)));
          }
        }
      }
    }
    this.editKPIInformationForm.controls['kpiScore'].setValue(
      Number.isInteger(
        (this.editKPIInformationForm.value.percentageAchievement / 100 * this.editKPIInformationForm.value.weightage)?.toFixed(2))
        ? (this.editKPIInformationForm.value.percentageAchievement / 100 * this.editKPIInformationForm.value.weightage)?.toFixed(2) :
        (this.editKPIInformationForm.value.percentageAchievement / 100 * this.editKPIInformationForm.value.weightage)?.toFixed(2));
  }
  toProperCase(str: string) {
    if (str == null) {
      return null
    } else {
      return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
    }
  }
  getWeightage() {
    var name = null
    if (this.operation == 'Edit') {
      name = 'Update'
    } else {
      name = 'Add'
    }
    const request = {
      "id": this.kpiId,
      "companyId": this.loggedInUserCompanyID,
      "month": this.editKPIInformationForm.value.month,
      "name": name,
      "userId": this.selectedUserID,
      "year": this.fromYear + '-' + this.toYear
    }
    this.httpService.callPostService(this.config.getWeightage, request).subscribe((data: any) => {
      if (data?.status) {
        if (data.data + this.editKPIInformationForm.value.weightage <= 100) {
          this.invalidReviewCycleWeightage = false;
        } else {
          this.invalidReviewCycleWeightage = true;
        }
      }
    })
  }
  // get disableAfterGoalApprove(): boolean {
  //   console.log(this.goalApprovalStatus)
  //   return ;
  // }
  downloadMisFile(url: any, fileName: any) {
    console.log(url, fileName);
    saveAs(url, fileName);
  }
  viewDocument(fileUrl: any) {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }

  pmsUnlockStatusListByUser: any = [];
  isUnLockIsOn: boolean = false;
  getPmsUnlockSetupForUser() {
    const request = {
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.getPmsUnlockSetupForUser, request).subscribe((data: any) => {
      this.pmsUnlockStatusListByUser = data?.data?.pmsUnlockStatus;
      const currentDate = new Date();
      currentDate.getTime();
      for (let i = 0; i < this.pmsUnlockStatusListByUser.length; i++) {
        for (let j = 0; j < this.pmsUnlockStatusListByUser[i].month.length; j++) {
          if (this.editKPIInformationForm.value.month == this.pmsUnlockStatusListByUser[i].month[j]) {
            let relockDate = new Date(this.pmsUnlockStatusListByUser[i].relockDate);
            relockDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);
            if (relockDate.getTime() >= currentDate.getTime()) {
              this.isUnLockIsOn = true;
            }
          }
        }
      }
      if ((!this.goalApprovalStatus && (this.selectedTab === 'Team Goals' || this.selectedTab === 'My Goals'))
        || this.selectedTab === 'Employee Goals' || this.isUnLockIsOn) {
        this.isFieldsDisabled = false;
      } else {
        this.isFieldsDisabled = true;
      }
    })
  }
  isCuttofDateActive: boolean = false;
  checkPMSSetup() {
    const today = new Date();
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      this.isCuttofDateActive = false;
    } else {
      if (this.cutoffDateApplicable) {
        var toMonth = this.editKPIInformationForm.value.month?.split('-');
        const calculatedCutoffDate = this.calculateEndOfMonthDateFromMonthName(toMonth[0], this.cutoffDate);
        calculatedCutoffDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        let calculatedDateCutoffDateNumber = calculatedCutoffDate.getTime();
        let todayDateNumber = today.getTime();
        if (calculatedDateCutoffDateNumber < todayDateNumber) {
          const calculatedCutoffDateAndGracePeriod = this.calculateEndOfMonthDateFromMonthName(toMonth[0], this.cutoffDate
            + this.gracePeriod);
          calculatedCutoffDateAndGracePeriod.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
          let calculatedutoffDateAndGracePeriodDateNumber = calculatedCutoffDateAndGracePeriod.getTime();
          let todayDateNumber = today.getTime();
          if (calculatedutoffDateAndGracePeriodDateNumber >= todayDateNumber) {

          } else {
            this.isCuttofDateActive = true;
          }
        } else {
          this.isCuttofDateActive = false;
        }
      } else {
        this.isCuttofDateActive = false;
      }
    }
  }
  convertMonthNameToDate(monthName: string, year: number = new Date().getFullYear()): Date {
    const monthIndex = this.getMonthIndex1(monthName);
    if (monthIndex === -1) {
      throw new Error("Invalid month name");
    }
    return new Date(year, monthIndex + 1, 0); // First day of the month
  }

  calculateEndOfMonthDateFromMonthName(monthName: string, daysToAdd: number, year?: number): Date {
    const startDate = this.convertMonthNameToDate(monthName, year);
    const resultDate = new Date(startDate);
    resultDate.setDate(resultDate.getDate() + daysToAdd);

    const endOfMonthDate = new Date(resultDate.getFullYear(), resultDate.getMonth() + 1, 0); // The 0th day of the next month is the last day of the current month

    if (resultDate > endOfMonthDate) {
      return endOfMonthDate;
    } else {
      return resultDate;
    }
  }
  getMonthIndex1(monthName: string): number {
    const months = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
    return months.indexOf(monthName);
  }
  isUserValidToAddKPI: any = true;;
  dojMonth: any;
  checkUserByDojAndDoe() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "from": this.editKPIInformationForm.value.month,
      "fromYear": this.fromYear,
      "to": this.editKPIInformationForm.value.month,
      "toYear": this.toYear,
      "userId": this.selectedUserID
    }
    this.httpService.callPostService(this.config.checkUserByDojAndDoe, request).subscribe((data: any) => {
      this.isUserValidToAddKPI = data?.data?.check;
      if (!this.isUserValidToAddKPI) {
        this.dojMonth = this.datePipe.transform(data?.data?.doj, 'MMM');
      }
    })
  }
  commentLength: boolean = false;
  checkLengthOfField(string: any) {
    if (string?.length > 255) {
      this.commentLength = true;
      this.toastr.error('The text cannot exceed 255 characters.', '', {
        timeOut: 3000,
      });
    } else {
      this.commentLength = false;
    }
  }


  misPriview(event: any, filename: any) {
    console.log(event, filename);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    // dialogConfig.height = '90%';
    // dialogConfig.width = '70%';   // Try setting width to a smaller value
    dialogConfig.width = window.innerWidth <= 576 ? '100%' : '80%';
    // dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    dialogConfig.panelClass = 'custom-dialog-container';  // Only set this class once
    dialogConfig.data = {
      msiAttached: event,
      filename: filename
    };

    const dialogRef = this.dialog.open(MisAttachmentViewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }
}

